import { render } from "./CommonInputField.vue?vue&type=template&id=6b23e2ca"
import script from "./CommonInputField.vue?vue&type=script&lang=js"
export * from "./CommonInputField.vue?vue&type=script&lang=js"

import "./CommonInputField.vue?vue&type=style&index=0&id=6b23e2ca&lang=scss"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__